import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, IconButton } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import AddIcon from "@material-ui/icons/Add";
import { customerEligibilityData } from "assets/properties/properties";

const InsuredEligibilityCreate = ({ classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [disabledButton, setDisabledButton] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [lastIndex, setLastIndex] = useState(0);
  const [customerEligibilityError, setCustomerEligibilityError] =
    useState(false);
  const [groupDetails, setGroupDetails] = useState([
    {
      dependency: "",
      min: "",
      max: "",
    },
  ]);
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.INSURED_ELIGIBILITY_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data?.user_description) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      if (result?.data?.length > 0) {
        // Map the incoming data to match the format expected in `groupDetails`
        const mappedData = result.data
          .map((item) => {
            const newEntries = [];
            if (item.minAge !== undefined && item.maxAge !== undefined) {
              newEntries.push({
                dependency: "Age",
                min: item.minAge,
                max: item.maxAge,
              });
            }
            if (item.minBmi !== undefined && item.maxBmi !== undefined) {
              newEntries.push({
                dependency: "Bmi",
                min: item.minBmi,
                max: item.maxBmi,
              });
            }
            if (
              item.minLoanAmt !== undefined &&
              item.maxLoanAmt !== undefined
            ) {
              newEntries.push({
                dependency: "Loan Amount",
                min: item.minLoanAmt,
                max: item.maxLoanAmt,
              });
            }
            return newEntries;
          })
          .flat(); // Flatten the array of arrays
        setShowAdditionalFields(true);
        setGroupDetails(mappedData);
        setLastIndex(mappedData.length - 1);
      }
    }
  };
  const addNextRow = () => {
    let newIndex = lastIndex + 1;
    setLastIndex(newIndex);
    let newArr = [...groupDetails]; // copying the old datas array
    newArr[newIndex] = {
      dependency: "",
      min: "",
      max: "",
    };
    setGroupDetails(newArr);
  };
  const isValidate = () => {
    for (const detail of groupDetails) {
      const { dependency, min, max } = detail;
      if (dependency === "Age") {
        if (
          Number(min) < 18 ||
          Number(max) > 60 ||
          Number(min) >= Number(max)
        ) {
          toastUpdate(
            "Error",
            "Age must be greater than 18 and less than 60. Min should be less than Max.",
            true
          );
          setDisabledButton(true);
          return false;
        }
      }

      if (dependency === "Bmi") {
        if (
          Number(min) < 18 ||
          Number(max) > 28 ||
          Number(min) >= Number(max)
        ) {
          toastUpdate(
            "Error",
            "BMI min should be greater than or equal to 18 and max should be less than or equal to 28. Min should be less than Max.",
            true
          );
          setDisabledButton(true);
          return false;
        }
      }

      if (dependency === "Loan Amount") {
        if (
          Number(min) < 20000 ||
          Number(max) > 1000000 ||
          Number(min) >= Number(max)
        ) {
          toastUpdate(
            "Error",
            "Loan Amount min should be greater than or equal to 20000 and max should be less than or equal to 1000000. Min should be less than Max.",
            true
          );
          setDisabledButton(true);
          return false;
        }
      }
    }
    setDisabledButton(false);
    return true; // All validations passed
  };
  const saveInformation = async () => {
    if (isValidate()) {
      const formattedData = groupDetails.reduce((acc, group) => {
        switch (group.dependency) {
          case "Age":
            acc.minAge = group?.min;
            acc.maxAge = group?.max;
            break;
          case "Bmi":
            acc.minBmi = group?.min;
            acc.maxBmi = group?.max;
            break;
          case "Loan Amount":
            acc.minLoanAmt = group?.min;
            acc.maxLoanAmt = group?.max;
            break;
          default:
            break;
        }
        return acc;
      }, {});
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.INSURED_ELIGIBILITY_CREATE,
        method: "POST",
        authToken: authToken,
        data: [formattedData],
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
        return "ERROR";
      } else {
        return "SUCCESS";
      }
    }
  };
  const handleChange = (e, index, label) => {
    const newValue = e;
    const regex = /^[0-9\b]+$/;
    if (newValue === "" || regex.test(newValue)) {
      setDisabledButton(false);
      setGroupDetails((prev) => {
        const updatedDetails = [...prev];
        updatedDetails[index][label] = newValue;
        return updatedDetails;
      });
    }
  };
  const handleInsuranceSubmit = async (event) => {
    toastUpdate("", "", false);
    let status = await saveInformation();
    if (status === "SUCCESS") {
      const msg = "Insurance Eligiblity created successfully!";
      toastUpdate("Success", msg, true);
      setRedirectURL(`/coreservice/InsuranceEligibility`);
    }
  };

  const handleCancel = () => {
    navigate("/coreservice/InsuranceEligibility");
  };
  const handleSelectChange = (value, index, label) => {
    setShowAdditionalFields(true);

    setGroupDetails((prev) =>
      prev.map((item, idx) =>
        idx === index
          ? {
              ...item,
              dependency: value,
              min: item.min || "",
              max: item.max || "",
            }
          : item
      )
    );

    // Add a new entry if the index is out of bounds of the current array length
    setGroupDetails((prev) => {
      if (index >= prev.length) {
        return [...prev, { dependency: value, min: "", max: "" }];
      }
      return prev;
    });
  };

  const getDisabledOptions = () => {
    // Get the dependencies already selected in groupDetails
    return groupDetails.map((detail) => detail.dependency);
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            params.id
              ? "Edit Insurance Eligiblity"
              : "Create Insurance Eligiblity"
          }
          button1="Save"
          button2="Cancel"
          button1click={handleInsuranceSubmit}
          button2click={handleCancel}
          disabled1={disabledButton}
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          {/* {Array.apply(null, { length: lastIndex + 1 }).map((e, i) => ( */}
          {groupDetails?.map((e, i) => (
            <React.Fragment key={`group-detail-${i}`}>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.fieldContaienr}
              >
                <CustomSelectNew
                  label="Select Eligibility*"
                  id={`eligibility-${i}`}
                  value={e?.dependency}
                  setState={handleSelectChange}
                  data={customerEligibilityData}
                  disabledOptions={getDisabledOptions()}
                  error={customerEligibilityError}
                  setError={setCustomerEligibilityError}
                  type="newSchemeCharge"
                  index={i}
                />
              </Grid>
              {showAdditionalFields && (
                <>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomeTextField
                      label={`Min ${e?.dependency || ""}`}
                      required
                      id="min"
                      index={i}
                      value={e?.min}
                      setState={handleChange}
                      type="insurance"
                      textLabel="min"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    className={classes.fieldContaienr}
                  >
                    <CustomeTextField
                      label={`Max ${e?.dependency || ""}`}
                      required
                      id="max"
                      index={i}
                      value={e?.max}
                      setState={handleChange}
                      type="insurance"
                      textLabel="max"
                    />
                  </Grid>
                  {customerEligibilityData.length - 1 > lastIndex && (
                    <IconButton
                      aria-label="Delete Disbursal"
                      onClick={() => {
                        addNextRow();
                      }}
                      style={{ padding: "0px", marginTop: "2%" }}
                    >
                      {lastIndex === i && (
                        <AddIcon
                          style={{
                            color: "green",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </IconButton>
                  )}
                </>
              )}
            </React.Fragment>
          ))}
        </Grid>
      </Grid>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default InsuredEligibilityCreate;
